import React from 'react';
import { Users, TrendingUp, Globe, Award, Target, Zap } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const PlatformBenefits: React.FC = () => {
  const benefits = [
    {
      icon: Users,
      title: 'Access to Vienna Tourists',
      description: 'Reach thousands of tourists actively exploring Vienna attractions',
      stat: '10,000+ active users',
    },
    {
      icon: TrendingUp,
      title: 'Increased Revenue',
      description: 'Partners see average 30% increase in tourist customer base',
      stat: '30% avg growth',
    },
    {
      icon: Globe,
      title: 'Digital Visibility',
      description: 'Featured placement in our app used by tourists planning Vienna visits',
      stat: '24/7 exposure',
    },
    {
      icon: Award,
      title: 'Zero Commission',
      description: 'We do not charge commission on redemptions - keep 100% of revenue',
      stat: '0% commission',
    },
    {
      icon: Target,
      title: 'Targeted Marketing',
      description: 'Reach tourists based on interests, location, and travel preferences',
      stat: 'Smart targeting',
    },
    {
      icon: Zap,
      title: 'Easy Management',
      description: 'Simple dashboard to create offers, track redemptions, and analyze performance',
      stat: 'Quick setup',
    },
  ];

  return (
    <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-lg p-8 mb-8">
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-900 mb-3">
          Why Partner with TravelHeroes?
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          Join Vienna's leading tourism platform and connect with travelers discovering the city
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {benefits.map((benefit, index) => {
          const Icon = benefit.icon;
          return (
            <div
              key={index}
              className="bg-white rounded-lg p-6 shadow-sm hover:shadow-md transition-shadow"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0">
                  <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center">
                    <Icon className="w-6 h-6 text-indigo-600" />
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="font-semibold text-gray-900 mb-1">
                    {benefit.title}
                  </h3>
                  <p className="text-sm text-gray-600 mb-2">
                    {benefit.description}
                  </p>
                  <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                    {benefit.stat}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 p-6 bg-white rounded-lg border-2 border-indigo-200">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Ready to Grow Your Business?
            </h3>
            <p className="text-gray-600">
              Complete the application below to join our partner network
            </p>
          </div>
          <div className="text-right">
            <div className="text-2xl font-bold text-indigo-600">7</div>
            <div className="text-sm text-gray-600">Active Partners</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformBenefits;